// src/pages/Departments.jsx
// Rediseño visual aplicado 2026-05-13. Lógica preservada 1:1.
import React, { useEffect, useState, useContext } from 'react';
import { Spinner, Modal } from 'react-bootstrap';
import api from '../services/api';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-toastify';


const Icon = ({ children, size = 16, stroke = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke}
         strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {children}
    </svg>
);
const I = {
    plus:   <Icon size={14}><path d="M12 5v14" /><path d="M5 12h14" /></Icon>,
    x:      <Icon size={12}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></Icon>,
    edit:   <Icon size={12}><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></Icon>,
    trash:  <Icon size={12}><path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /></Icon>,
    file:   <Icon size={12}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /></Icon>,
    branch: <Icon size={12}><path d="M9 18 13.5 13.5" /><path d="M9 18V8.5A1.5 1.5 0 0 1 10.5 7H17" /><circle cx="9" cy="18" r="1.5" /><circle cx="17" cy="7" r="1.5" /></Icon>,
    check:  <Icon size={14}><path d="M20 6 9 17l-5-5" /></Icon>,
    arrow:  <Icon size={12}><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></Icon>,
};


const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
/* Tokens de la página. También en .dp-modal: react-bootstrap monta el Modal en
   <body>, fuera de .dp-root, y sin esto los botones del modal quedaban sin color. */
.dp-root, .dp-modal {
    --dp-accent: var(--brand-700, #0a4aa8);
    --dp-accent-hover: var(--brand-800, #07357f);
    --dp-accent-light: #dbeafe;
    --dp-accent-ring: rgba(10, 74, 168, .12);
}
.dp-root {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    max-width: 880px; margin: 0 auto; padding: 24px 20px 60px;
    color: var(--c-text-1);
}
.dp-root * { box-sizing: border-box; }
.dp-title { font-size: 24px; font-weight: 700; margin: 0 0 4px; letter-spacing: -0.01em; }
.dp-subtitle { color: var(--c-text-3); font-size: 13.5px; margin: 0 0 22px; line-height: 1.5; }

/* Create form */
.dp-create {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 14px; padding: 18px 22px; margin-bottom: 22px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
}
.dp-create-title {
    font-size: 11px; font-weight: 700; letter-spacing: 0.5px;
    text-transform: uppercase; color: var(--c-text-4); margin: 0 0 12px;
}
.dp-parent-tag {
    display: inline-flex; align-items: center; gap: 6px;
    background: var(--dp-accent-light); color: var(--dp-accent);
    border-radius: 999px; padding: 4px 12px;
    font-size: 12px; font-weight: 600; margin-bottom: 10px;
}
.dp-link-btn {
    background: none; border: none; padding: 0; color: var(--dp-accent);
    font-size: 12px; cursor: pointer; font-family: inherit;
    margin-left: 8px; text-decoration: underline;
}

/* Inputs */
.dp-input, .dp-select, .dp-textarea {
    width: 100%; padding: 9px 12px;
    font-size: 14px; font-family: inherit; line-height: 1.5;
    border: 1px solid var(--c-border); border-radius: 8px;
    background: var(--c-input-bg); color: var(--c-text-1);
    outline: none;
    transition: border-color .15s, box-shadow .15s;
}
.dp-input:focus, .dp-select:focus, .dp-textarea:focus {
    border-color: var(--dp-accent); box-shadow: 0 0 0 3px var(--dp-accent-ring);
}
.dp-input.sm, .dp-select.sm { padding: 6px 10px; font-size: 13px; border-radius: 7px; }
.dp-textarea { resize: vertical; min-height: 70px; }

/* Buttons */
.dp-btn {
    display: inline-flex; align-items: center; gap: 6px;
    border: 1px solid transparent; border-radius: 8px;
    padding: 8px 14px; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: inherit;
    transition: all .15s;
}
.dp-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.dp-btn.sm { padding: 5px 10px; font-size: 12px; }
.dp-btn-primary { background: var(--dp-accent); color: #fff; border-color: var(--dp-accent); }
.dp-btn-primary:hover:not(:disabled) { background: var(--dp-accent-hover); border-color: var(--dp-accent-hover); }
.dp-btn-success { background: #059669; color: #fff; border-color: #059669; }
.dp-btn-success:hover:not(:disabled) { background: #047857; border-color: #047857; }
.dp-btn-ghost { background: transparent; color: var(--c-text-2); border-color: var(--c-border); }
.dp-btn-ghost:hover:not(:disabled) { background: var(--c-msg-bg); border-color: var(--c-text-3); }
.dp-btn-info { background: transparent; color: var(--dp-accent); border-color: var(--c-border); }
.dp-btn-info:hover:not(:disabled) { background: var(--dp-accent-light); border-color: var(--dp-accent); }
.dp-btn-danger { background: transparent; color: #dc2626; border-color: #fecaca; }
.dp-btn-danger:hover:not(:disabled) { background: var(--c-priority-urgent-bg); border-color: #dc2626; }

/* Department tree */
.dp-list { display: flex; flex-direction: column; gap: 10px; }
.dp-row {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 12px; padding: 14px 18px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
    display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;
    transition: transform .15s, box-shadow .15s;
}
.dp-row:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(15,23,42,.06); }
.dp-row-info { flex: 1; min-width: 0; }
.dp-row-name {
    display: flex; align-items: center; gap: 8px; margin: 0;
    font-weight: 700; font-size: 14px; color: var(--c-text-1);
}
.dp-row-name .child-arrow { color: var(--c-text-4); font-size: 14px; }
.dp-root-badge {
    background: var(--c-msg-bg); color: var(--c-text-3);
    border-radius: 4px; padding: 1px 7px;
    font-size: 10px; font-weight: 600; letter-spacing: 0.3px;
    text-transform: uppercase;
}
.dp-row-desc { color: var(--c-text-3); font-size: 13px; margin: 4px 0 8px; }
.dp-row-meta { display: flex; flex-wrap: wrap; gap: 6px; }
.dp-case-tag {
    background: var(--c-msg-bg); color: var(--c-text-2);
    border-radius: 5px; padding: 2px 9px; font-size: 11px;
}
.dp-template-tag {
    background: var(--dp-accent-light); color: var(--dp-accent);
    border-radius: 5px; padding: 2px 9px; font-size: 11px; font-weight: 600;
    display: inline-flex; align-items: center; gap: 4px;
}
.dp-more-tag { color: var(--c-text-4); font-size: 11px; align-self: center; }

.dp-row-actions { display: flex; gap: 6px; flex-shrink: 0; flex-wrap: wrap; justify-content: flex-end; }

.dp-children {
    margin-left: 28px;
    border-left: 2px solid var(--c-card-header-border);
    padding-left: 14px;
    margin-top: 8px;
    display: flex; flex-direction: column; gap: 8px;
}

.dp-empty { color: var(--c-text-4); text-align: center; padding: 40px 0; font-size: 13.5px; }

/* Modal */
.modal-content { background: var(--c-card) !important; border: 1px solid var(--c-border) !important; }
.dp-mlabel {
    font-size: 13px; font-weight: 600; color: var(--c-text-2);
    margin-bottom: 6px; display: block;
}
.dp-mhint {
    font-size: 11.5px; color: var(--c-text-4); margin: 4px 0 0; line-height: 1.5;
}
.dp-mgroup { margin-bottom: 16px; }
.dp-msection-divider { height: 1px; background: var(--c-card-header-border); margin: 18px 0 14px; border: none; }

/* Material types list */
.dp-mat-row {
    display: flex; align-items: center; gap: 8px;
    border: 1px solid var(--c-border); border-radius: 8px;
    padding: 6px 10px; background: var(--c-card);
}
.dp-mat-row.inactive { opacity: 0.55; background: transparent; }
.dp-mat-suffix { font-size: 11px; color: var(--c-text-4); flex-shrink: 0; }

.dp-add-row { display: flex; gap: 6px; }
.dp-add-row .dp-input { flex: 1; border-radius: 8px 0 0 8px; border-right: none; }
.dp-add-row .dp-input:nth-child(2) { border-radius: 0; max-width: 110px; border-right: none; }
.dp-add-row .dp-input:focus, .dp-add-row .dp-input:focus + * { z-index: 1; }
.dp-add-row .dp-btn { border-radius: 0 8px 8px 0; flex-shrink: 0; }

/* Switch */
.dp-switch { position: relative; display: inline-block; width: 40px; height: 22px; flex-shrink: 0; cursor: pointer; }
.dp-switch input { opacity: 0; width: 0; height: 0; }
.dp-switch-slider {
    position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
    background: var(--c-border); border-radius: 22px; transition: background .2s;
}
.dp-switch-slider::before {
    position: absolute; content: ''; height: 16px; width: 16px; left: 3px; bottom: 3px;
    background: #fff; border-radius: 50%; transition: transform .2s;
    box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.dp-switch input:checked + .dp-switch-slider { background: var(--dp-accent); }
.dp-switch input:checked + .dp-switch-slider::before { transform: translateX(18px); }
.dp-switch.sm { width: 32px; height: 18px; }
.dp-switch.sm .dp-switch-slider::before { height: 12px; width: 12px; }
.dp-switch.sm input:checked + .dp-switch-slider::before { transform: translateX(14px); }

.dp-flag-row { display: flex; align-items: center; gap: 10px; }
.dp-flag-label { font-size: 13px; color: var(--c-text-1); cursor: pointer; }

/* Case chips */
.dp-case-chip {
    display: inline-flex; align-items: center; gap: 6px;
    background: var(--c-msg-bg); color: var(--c-text-2);
    border: 1px solid var(--c-border);
    border-radius: 999px; padding: 3px 10px;
    font-size: 12px;
}
.dp-case-chip button {
    background: none; border: none; color: var(--c-text-4);
    cursor: pointer; padding: 0; display: inline-flex;
    transition: color .15s;
}
.dp-case-chip button:hover { color: #dc2626; }

/* Auto-assign radios */
.dp-radio-group { display: flex; flex-direction: column; gap: 8px; }
.dp-radio-row { display: flex; align-items: flex-start; gap: 10px; }
.dp-radio-row input[type="radio"] { accent-color: var(--dp-accent); margin-top: 3px; }
.dp-radio-label { font-size: 13px; color: var(--c-text-1); cursor: pointer; line-height: 1.5; }
.dp-radio-label b { font-weight: 700; }

/* Participants */
.dp-agent-card {
    border: 1px solid var(--c-border); border-radius: 8px;
    padding: 8px 12px; background: var(--c-card);
}
.dp-agent-card.selected { background: var(--c-msg-bg); border-color: var(--dp-accent); }
.dp-agent-row {
    display: flex; align-items: center; gap: 8px;
    font-size: 13px;
}
.dp-agent-row input[type="checkbox"] { accent-color: var(--dp-accent); }
.dp-agent-name { color: var(--c-text-1); }
.dp-agent-email { color: var(--c-text-4); font-size: 11px; margin-left: 4px; }

.dp-cases-row {
    margin-top: 8px; padding-left: 24px;
    display: flex; flex-wrap: wrap; gap: 5px;
}
.dp-case-pill {
    cursor: pointer; padding: 3px 9px; border-radius: 999px;
    font-size: 11.5px; font-weight: 500;
    background: var(--c-card); color: var(--c-text-2);
    border: 1px solid var(--c-border);
    transition: all .12s;
}
.dp-case-pill:hover { border-color: var(--dp-accent); color: var(--dp-accent); }
.dp-case-pill.active { background: var(--dp-accent); color: #fff; border-color: var(--dp-accent); }
.dp-cases-empty { font-size: 11px; color: var(--c-text-4); font-style: italic; width: 100%; }

.dp-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }

.dp-access-denied {
    background: var(--c-priority-urgent-bg); color: #b91c1c;
    border: 1px solid #fecaca; border-radius: 12px;
    padding: 24px; text-align: center; font-size: 14px;
}
`;


// ── Subcomponentes ──────────────────────────────────────────────────────────
function DeptRow({ d, isChild = false, isAdmin, onEdit, onDelete, onCreateChild, canCreateChild }) {
    return (
        <div className="dp-row">
            <div className="dp-row-info">
                <p className="dp-row-name">
                    {isChild && <span className="child-arrow">↳</span>}
                    {d.name}
                    {!isChild && !d.parent && <span className="dp-root-badge">Padre</span>}
                </p>
                {d.description && <p className="dp-row-desc">{d.description}</p>}
                {((d.ticketCases || []).length > 0 || d.ticketTemplate) && (
                    <div className="dp-row-meta">
                        {(d.ticketCases || []).slice(0, 4).map((c, i) => (
                            <span key={i} className="dp-case-tag">{c}</span>
                        ))}
                        {(d.ticketCases || []).length > 4 && (
                            <span className="dp-more-tag">+{d.ticketCases.length - 4} más</span>
                        )}
                        {d.ticketTemplate && (
                            <span className="dp-template-tag">{I.file} Plantilla</span>
                        )}
                    </div>
                )}
            </div>
            <div className="dp-row-actions">
                {canCreateChild && onCreateChild && !isChild && (
                    <button type="button" className="dp-btn dp-btn-info sm" onClick={onCreateChild}>
                        {I.branch} Crear hijo
                    </button>
                )}
                <button type="button" className="dp-btn dp-btn-ghost sm" onClick={() => onEdit(d)}>
                    {I.edit} Editar
                </button>
                {isAdmin && (
                    <button type="button" className="dp-btn dp-btn-danger sm" onClick={() => onDelete(d._id)}>
                        {I.trash} Eliminar
                    </button>
                )}
            </div>
        </div>
    );
}


export default function Departments() {
    const { user } = useContext(AuthContext);
    const [depts,       setDepts]       = useState([]);
    const [name,        setName]        = useState('');
    const [description, setDescription] = useState('');
    const [parentForCreate, setParentForCreate] = useState('');
    const [loading,     setLoading]     = useState(true);
    const [creating,    setCreating]    = useState(false);

    const [showEdit,     setShowEdit]     = useState(false);
    const [editDept,     setEditDept]     = useState(null);
    const [editName,     setEditName]     = useState('');
    const [editDesc,     setEditDesc]     = useState('');
    const [editCases,    setEditCases]    = useState([]);
    const [editTemplate, setEditTemplate] = useState('');
    const [editSlaMode,  setEditSlaMode]  = useState('priority');
    const [editParent,   setEditParent]   = useState('');
    const [newCase,      setNewCase]      = useState('');
    const [savingEdit,   setSavingEdit]   = useState(false);

    const [editMaterialTypes,        setEditMaterialTypes]        = useState([]);
    const [editAllowExtendedUploads, setEditAllowExtendedUploads] = useState(false);
    const [newMatName,               setNewMatName]               = useState('');
    const [newMatHours,              setNewMatHours]              = useState('');

    const [aaEnabled,      setAaEnabled]      = useState(false);
    const [aaStrategy,     setAaStrategy]     = useState('round-robin');
    const [aaParticipants, setAaParticipants] = useState([]);
    const [aaAgents,       setAaAgents]       = useState([]);

    const DEFAULT_BREAKS = { enabled: true, lunchMinutes: 60, shortMinutes: 15, lunchPerDay: 1, shortPerDay: 2 };
    const [aaBreaks, setAaBreaks] = useState(DEFAULT_BREAKS);

    // Guardias de sábado (rotación automática)
    const DEFAULT_SLOTS = [
        { key: 'oficina-0900-1400', label: 'Oficina',     mode: 'oficina', start: '09:00', end: '14:00', count: 2 },
        { key: 'home-1100-1500',    label: 'Home office', mode: 'home',    start: '11:00', end: '15:00', count: 1 },
        { key: 'home-1200-1700',    label: 'Home office', mode: 'home',    start: '12:00', end: '17:00', count: 1 },
        { key: 'home-1400-1900',    label: 'Home office', mode: 'home',    start: '14:00', end: '19:00', count: 1 },
    ];
    const DEFAULT_GUARD = { enabled: false, slots: DEFAULT_SLOTS, weeksAhead: 4, participants: [] };
    const [guard, setGuard] = useState(DEFAULT_GUARD);
    const updateSlot = (i, patch) => setGuard(g => ({ ...g, slots: g.slots.map((s, idx) => idx === i ? { ...s, ...patch } : s) }));
    const removeSlot = (i) => setGuard(g => ({ ...g, slots: g.slots.filter((_, idx) => idx !== i) }));
    const addSlot = () => setGuard(g => ({ ...g, slots: [...g.slots, { key: '', label: 'Home office', mode: 'home', start: '09:00', end: '14:00', count: 1 }] }));

    const isAdmin         = user?.role === 'admin';
    const isLeaderRole    = user?.role === 'leader';
    const isAgentWithAuth = user?.role === 'agent' && user?.canAuthorize;

    useEffect(() => {
        api.get('/departments')
            .then(res => {
                let data = res.data;
                if ((isLeaderRole || isAgentWithAuth) && user?.departments?.length) {
                    const assignedIds = new Set(user.departments.map(d => String(d._id || d)));
                    for (const d of data) {
                        if (d.parent && assignedIds.has(String(d.parent._id || d.parent))) {
                            assignedIds.add(String(d._id));
                        }
                    }
                    data = data.filter(d => assignedIds.has(String(d._id)));
                }
                setDepts(data);
            })
            .catch(err => toast.error(err.response?.data?.error || 'Error al cargar'))
            .finally(() => setLoading(false));
    }, [isAdmin, isLeaderRole, isAgentWithAuth, user?.departments]);

    const rootDepts = depts.filter(d => !d.parent);
    const childrenOf = (parentId) => depts.filter(d => String(d.parent?._id || d.parent || '') === String(parentId));

    const handleCreate = async e => {
        e.preventDefault();
        if (!name.trim()) { toast.warn('El nombre es obligatorio'); return; }
        setCreating(true);
        try {
            const payload = { name, description };
            if (parentForCreate) payload.parent = parentForCreate;
            const res = await api.post('/departments', payload);
            setDepts(prev => [...prev, res.data].sort((a, b) => a.name.localeCompare(b.name)));
            setName(''); setDescription(''); setParentForCreate('');
            toast.success(parentForCreate ? 'Departamento hijo creado' : 'Departamento creado');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Error al crear');
        } finally { setCreating(false); }
    };

    const openEdit = dept => {
        setEditDept(dept);
        setEditName(dept.name);
        setEditDesc(dept.description || '');
        setEditCases(dept.ticketCases || []);
        setEditTemplate(dept.ticketTemplate || '');
        setEditSlaMode(dept.slaMode || 'priority');
        setEditParent(String(dept.parent?._id || dept.parent || ''));
        setEditMaterialTypes((dept.materialTypes || []).map(t => ({
            name: t.name, slaHours: Number(t.slaHours) || 0, active: t.active !== false,
        })));
        setEditAllowExtendedUploads(!!dept.allowExtendedUploads);
        setNewMatName(''); setNewMatHours(''); setNewCase('');

        const aa = dept.autoAssign || {};
        setAaEnabled(!!aa.enabled);
        setAaStrategy(aa.strategy || 'round-robin');
        setAaParticipants((aa.participants || []).map(p => {
            if (p && typeof p === 'object' && p.user) {
                return { user: String(p.user._id || p.user), cases: Array.isArray(p.cases) ? p.cases : [] };
            }
            return { user: String(p._id || p), cases: [] };
        }));
        setAaBreaks({ ...DEFAULT_BREAKS, ...(aa.breaks || {}) });
        const wg = dept.weekendGuard || {};
        setGuard({
            ...DEFAULT_GUARD, ...wg,
            slots: (wg.slots && wg.slots.length) ? wg.slots.map(s => ({ ...s })) : DEFAULT_SLOTS,
            participants: (wg.participants || []).map(p => String(p?._id || p)),
        });
        api.get('/users?role=agent')
            .then(res => {
                const list = (res.data || []).filter(u =>
                    u.active !== false &&
                    (u.departments || []).some(d => String(d._id || d) === String(dept._id))
                );
                setAaAgents(list);
                // Quita de la selección a quien ya no es agente elegible (pasó a
                // admin/leader, se desactivó o perdió el depto): no sale en la
                // lista, así que no habría forma de desmarcarlo.
                const elegibles = new Set(list.map(a => String(a._id)));
                setAaParticipants(prev => prev.filter(p => elegibles.has(p.user)));
                setGuard(prev => ({ ...prev, participants: prev.participants.filter(id => elegibles.has(id)) }));
            })
            .catch(() => setAaAgents([]));

        setShowEdit(true);
    };

    const toggleParticipant = (uid) => {
        setAaParticipants(prev =>
            prev.some(p => p.user === uid)
                ? prev.filter(p => p.user !== uid)
                : [...prev, { user: uid, cases: [] }]
        );
    };

    const toggleGuardParticipant = (uid) =>
        setGuard(prev => ({
            ...prev,
            participants: prev.participants.includes(uid)
                ? prev.participants.filter(id => id !== uid)
                : [...prev.participants, uid],
        }));

    const toggleParticipantCase = (uid, caseName) => {
        setAaParticipants(prev => prev.map(p => {
            if (p.user !== uid) return p;
            const has = p.cases.includes(caseName);
            return { ...p, cases: has ? p.cases.filter(c => c !== caseName) : [...p.cases, caseName] };
        }));
    };

    useEffect(() => {
        const valid = new Set(editCases);
        setAaParticipants(prev => prev.map(p => ({
            ...p,
            cases: p.cases.filter(c => valid.has(c)),
        })));
    }, [editCases]);

    const addCase = () => {
        const val = newCase.trim();
        if (!val) return;
        if (!editCases.includes(val)) setEditCases(prev => [...prev, val]);
        setNewCase('');
    };
    const removeCase = i => setEditCases(prev => prev.filter((_, idx) => idx !== i));

    const addMaterialType = () => {
        const name = newMatName.trim();
        const hours = Number(newMatHours);
        if (!name) { toast.warn('Indica el nombre del tipo'); return; }
        if (!Number.isFinite(hours) || hours < 0) { toast.warn('Horas inválidas'); return; }
        if (editMaterialTypes.some(t => t.name.toLowerCase() === name.toLowerCase())) {
            toast.warn('Ya existe un tipo con ese nombre'); return;
        }
        setEditMaterialTypes(prev => [...prev, { name, slaHours: hours, active: true }]);
        setNewMatName(''); setNewMatHours('');
    };
    const updateMaterialType = (i, patch) =>
        setEditMaterialTypes(prev => prev.map((t, idx) => idx === i ? { ...t, ...patch } : t));
    const removeMaterialType = i =>
        setEditMaterialTypes(prev => prev.filter((_, idx) => idx !== i));

    const handleSaveEdit = async () => {
        if (!editName.trim()) { toast.warn('El nombre es obligatorio'); return; }
        setSavingEdit(true);
        try {
            const patchBody = {
                name: editName, description: editDesc,
                ticketCases: editCases, ticketTemplate: editTemplate,
                slaMode: editSlaMode,
                materialTypes: editMaterialTypes,
                allowExtendedUploads: editAllowExtendedUploads,
            };
            if (isAdmin) patchBody.parent = editParent || null;
            await api.patch(`/departments/${editDept._id}`, patchBody);
            const aaRes = await api.patch(`/departments/${editDept._id}/auto-assign`, {
                enabled:      aaEnabled,
                strategy:     aaStrategy,
                participants: aaParticipants,
                breaks:       aaBreaks,
            });
            if (guard.enabled) {
                if (!guard.slots.length) { toast.warn('Guardias: define al menos un turno'); setSavingEdit(false); return; }
                const bad = guard.slots.find(s => !s.start || !s.end || s.end <= s.start);
                if (bad) { toast.warn('Guardias: cada turno necesita hora de fin mayor que la de inicio'); setSavingEdit(false); return; }
            }
            const wgRes = await api.patch(`/departments/${editDept._id}/weekend-guard`, {
                enabled:      guard.enabled,
                slots:        guard.slots.map(s => ({ label: s.label, mode: s.mode, start: s.start, end: s.end, count: Number(s.count) || 1 })),
                weeksAhead:   Number(guard.weeksAhead) || 4,
                participants: guard.participants,
            });
            const merged = { ...aaRes.data, weekendGuard: wgRes.data.weekendGuard };
            setDepts(prev => prev.map(d => d._id === merged._id ? merged : d));
            toast.success('Departamento actualizado');
            setShowEdit(false);
        } catch (err) {
            toast.error(err.response?.data?.error || 'Error al actualizar');
        } finally { setSavingEdit(false); }
    };

    const handleDelete = async id => {
        if (!window.confirm('¿Eliminar departamento?')) return;
        try {
            await api.delete(`/departments/${id}`);
            setDepts(prev => prev.filter(d => d._id !== id));
            toast.info('Departamento eliminado');
        } catch { toast.error('Error al eliminar'); }
    };

    if (!isAdmin && !isLeaderRole && !isAgentWithAuth) {
        return (
            <>
                <style>{CSS}</style>
                <div className="dp-root">
                    <div className="dp-access-denied">
                        Solo administradores y agentes autorizadores pueden gestionar departamentos.
                    </div>
                </div>
            </>
        );
    }

    const parentDoc = parentForCreate ? depts.find(d => String(d._id) === parentForCreate) : null;

    return (
        <>
            <style>{CSS}</style>
            <div className="dp-root">
                <h1 className="dp-title">Departamentos</h1>
                <p className="dp-subtitle">
                    {isAdmin ? 'Crea y configura los departamentos de atención' : 'Configura los casos predefinidos y plantillas de tus departamentos'}
                </p>

                {isAdmin && (
                    <div className="dp-create">
                        <p className="dp-create-title">
                            {parentDoc ? `Nuevo depto hijo de "${parentDoc.name}"` : 'Nuevo departamento'}
                        </p>
                        {parentDoc && (
                            <div className="dp-parent-tag">
                                {I.branch} Hijo de {parentDoc.name}
                                <button type="button" className="dp-link-btn" onClick={() => setParentForCreate('')}>
                                    Cancelar (crear como raíz)
                                </button>
                            </div>
                        )}
                        <form onSubmit={handleCreate}>
                            <input type="text" className="dp-input" value={name} onChange={e => setName(e.target.value)}
                                placeholder="Nombre del departamento" required style={{ marginBottom: 10 }} />
                            <textarea className="dp-textarea" rows={2} value={description}
                                onChange={e => setDescription(e.target.value)}
                                placeholder="Descripción (opcional)" style={{ marginBottom: 12 }} />
                            <button type="submit" className="dp-btn dp-btn-success" disabled={creating}>
                                {creating ? <Spinner size="sm" animation="border" /> : <>{I.plus} {parentDoc ? 'Crear hijo' : 'Crear departamento'}</>}
                            </button>
                        </form>
                    </div>
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: 60 }}><Spinner animation="border" variant="primary" /></div>
                ) : depts.length === 0 ? (
                    <p className="dp-empty">No hay departamentos aún.</p>
                ) : (
                    <div className="dp-list">
                        {rootDepts.map(d => {
                            const kids = childrenOf(d._id);
                            return (
                                <div key={d._id}>
                                    <DeptRow d={d} isAdmin={isAdmin} onEdit={openEdit} onDelete={handleDelete}
                                        onCreateChild={() => { setParentForCreate(String(d._id)); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                                        canCreateChild={isAdmin} />
                                    {kids.length > 0 && (
                                        <div className="dp-children">
                                            {kids.map(k => (
                                                <DeptRow key={k._id} d={k} isChild isAdmin={isAdmin}
                                                    onEdit={openEdit} onDelete={handleDelete} />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Modal de edición */}
                <Modal className="dp-modal" show={showEdit} onHide={() => setShowEdit(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontWeight: 700, fontSize: 16 }}>Editar departamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="dp-mgroup">
                            <label className="dp-mlabel">Nombre</label>
                            <input className="dp-input" value={editName} onChange={e => setEditName(e.target.value)} required />
                        </div>

                        <div className="dp-mgroup">
                            <label className="dp-mlabel">Descripción</label>
                            <textarea className="dp-textarea" rows={2} value={editDesc} onChange={e => setEditDesc(e.target.value)} />
                        </div>

                        {isAdmin && (
                            <div className="dp-mgroup">
                                <label className="dp-mlabel">Departamento padre</label>
                                <select className="dp-select" value={editParent} onChange={e => setEditParent(e.target.value)}>
                                    <option value="">— Sin padre (es raíz) —</option>
                                    {depts.filter(d => !d.parent && String(d._id) !== String(editDept?._id))
                                        .map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                                </select>
                                <p className="dp-mhint">
                                    Solo se permite 1 nivel: un depto con hijos no puede convertirse en hijo. El líder del padre verá tickets y stats de los hijos.
                                </p>
                            </div>
                        )}

                        <div className="dp-mgroup">
                            <label className="dp-mlabel">Modo de SLA</label>
                            <select className="dp-select" value={editSlaMode} onChange={e => setEditSlaMode(e.target.value)} disabled={!isAdmin}>
                                <option value="priority">Por prioridad — usa horas configuradas</option>
                                <option value="deliveryDate">Por fecha de entrega — el solicitante define la fecha</option>
                                <option value="materialType">Por tipo de material — horas × cantidad (lineal)</option>
                            </select>
                            <p className="dp-mhint">
                                {editSlaMode === 'deliveryDate'
                                    ? 'El SLA será la fecha de entrega que indique el solicitante (el equipo puede negociarla).'
                                    : editSlaMode === 'materialType'
                                        ? 'El SLA se calcula como horas del tipo × cantidad de materiales (respeta horario laboral).'
                                        : 'El SLA se calcula a partir de la prioridad del ticket y las horas configuradas en SLA.'}
                            </p>
                        </div>

                        {editSlaMode === 'materialType' && (
                            <div className="dp-mgroup">
                                <label className="dp-mlabel">Tipos de material y horas por unidad</label>
                                <p className="dp-mhint" style={{ marginBottom: 10 }}>
                                    Define cuántas horas vale UNA unidad de cada tipo. El SLA del ticket = horas × cantidad.
                                </p>
                                {editMaterialTypes.length === 0 ? (
                                    <p style={{ color: 'var(--c-text-4)', fontSize: 12, fontStyle: 'italic', marginBottom: 8 }}>Sin tipos definidos aún.</p>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 10 }}>
                                        {editMaterialTypes.map((t, i) => (
                                            <div key={i} className={`dp-mat-row${t.active ? '' : ' inactive'}`}>
                                                <input type="text" className="dp-input sm"
                                                    style={{ flex: '2 1 0' }}
                                                    value={t.name} onChange={e => updateMaterialType(i, { name: e.target.value })} />
                                                <input type="number" min={0} step="0.5" className="dp-input sm"
                                                    style={{ flex: '0 0 100px' }}
                                                    value={t.slaHours} onChange={e => updateMaterialType(i, { slaHours: Number(e.target.value) })} />
                                                <span className="dp-mat-suffix">h/unidad</span>
                                                <label className="dp-switch sm" title="Activo">
                                                    <input type="checkbox" checked={t.active} onChange={e => updateMaterialType(i, { active: e.target.checked })} />
                                                    <span className="dp-switch-slider" />
                                                </label>
                                                <button type="button" className="dp-btn dp-btn-danger sm" onClick={() => removeMaterialType(i)} title="Quitar">{I.x}</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="dp-add-row">
                                    <input type="text" className="dp-input" placeholder="Nombre (ej. Flayer, Video, Campaña)"
                                        value={newMatName} onChange={e => setNewMatName(e.target.value)}
                                        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addMaterialType(); } }} />
                                    <input type="number" min={0} step="0.5" className="dp-input" placeholder="h/u"
                                        value={newMatHours} onChange={e => setNewMatHours(e.target.value)}
                                        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addMaterialType(); } }} />
                                    <button type="button" className="dp-btn dp-btn-info" onClick={addMaterialType}>Agregar</button>
                                </div>
                            </div>
                        )}

                        <div className="dp-mgroup">
                            <div className="dp-flag-row">
                                <label className="dp-switch">
                                    <input type="checkbox" checked={editAllowExtendedUploads}
                                        onChange={e => setEditAllowExtendedUploads(e.target.checked)} disabled={!isAdmin} />
                                    <span className="dp-switch-slider" />
                                </label>
                                <span className="dp-flag-label">
                                    Permitir subir videos (MP4) y ZIP en este depto (hasta 60 MB)
                                </span>
                            </div>
                            <p className="dp-mhint">
                                Por defecto solo se aceptan imágenes y documentos Office/PDF (8 MB). Habilita esto para equipos de diseño/multimedia.
                            </p>
                        </div>

                        <div className="dp-mgroup">
                            <label className="dp-mlabel">Plantilla de descripción</label>
                            <textarea className="dp-textarea" rows={4} value={editTemplate} onChange={e => setEditTemplate(e.target.value)}
                                placeholder="Ej. Describe el problema:&#10;- Desde cuándo ocurre&#10;- Pasos ya intentados" />
                            <p className="dp-mhint">Este texto se pre-cargará en la descripción al crear un ticket.</p>
                        </div>

                        <div className="dp-mgroup">
                            <label className="dp-mlabel">Casos predefinidos</label>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                                {editCases.map((c, i) => (
                                    <span key={i} className="dp-case-chip">
                                        {c}
                                        <button type="button" onClick={() => removeCase(i)} aria-label="Quitar">{I.x}</button>
                                    </span>
                                ))}
                                {editCases.length === 0 && (
                                    <span style={{ color: 'var(--c-text-4)', fontSize: 12, fontStyle: 'italic' }}>Sin casos aún.</span>
                                )}
                            </div>
                            <div className="dp-add-row">
                                <input type="text" className="dp-input" placeholder="Nuevo caso…" value={newCase}
                                    onChange={e => setNewCase(e.target.value)}
                                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addCase(); } }} />
                                <button type="button" className="dp-btn dp-btn-info" onClick={addCase}>Agregar</button>
                            </div>
                        </div>

                        <hr className="dp-msection-divider" />

                        <div className="dp-mgroup">
                            <div className="dp-flag-row">
                                <label className="dp-switch">
                                    <input type="checkbox" checked={aaEnabled} onChange={e => setAaEnabled(e.target.checked)} />
                                    <span className="dp-switch-slider" />
                                </label>
                                <span className="dp-flag-label">Activar auto-asignación al crearse un ticket</span>
                            </div>
                            <p className="dp-mhint">
                                El líder del departamento queda fuera de la rotación por diseño. Solo agentes activos del depto pueden participar.
                            </p>
                        </div>

                        {aaEnabled && (
                            <>
                                <div className="dp-mgroup">
                                    <label className="dp-mlabel">Estrategia</label>
                                    <div className="dp-radio-group">
                                        <div className="dp-radio-row">
                                            <input type="radio" id={`aa-rr-${editDept?._id}`} name={`aa-strategy-${editDept?._id}`}
                                                checked={aaStrategy === 'round-robin'} onChange={() => setAaStrategy('round-robin')} />
                                            <label htmlFor={`aa-rr-${editDept?._id}`} className="dp-radio-label">
                                                <b>Round-robin</b> — turnar equitativamente por orden
                                            </label>
                                        </div>
                                        <div className="dp-radio-row">
                                            <input type="radio" id={`aa-w-${editDept?._id}`} name={`aa-strategy-${editDept?._id}`}
                                                checked={aaStrategy === 'weighted'} onChange={() => setAaStrategy('weighted')} />
                                            <label htmlFor={`aa-w-${editDept?._id}`} className="dp-radio-label">
                                                <b>Ponderado</b> — asignar al agente en turno con menos carga: abiertos / en progreso más los que ya recibió hoy (empate: quien lleva más tiempo sin recibir)
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="dp-mgroup">
                                    <label className="dp-mlabel">
                                        Agentes en la rotación
                                        <span style={{ fontWeight: 400, color: 'var(--c-text-4)', marginLeft: 6 }}>
                                            ({aaParticipants.length} seleccionados)
                                        </span>
                                    </label>
                                    {editCases.length > 0 && (
                                        <p className="dp-mhint" style={{ marginBottom: 8 }}>
                                            Si no seleccionas casos para un agente, recibirá <b>todos los casos</b> (catch-all).
                                        </p>
                                    )}
                                    {aaAgents.length === 0 ? (
                                        <p style={{ color: 'var(--c-text-4)', fontSize: 12, fontStyle: 'italic' }}>
                                            No hay agentes activos asignados a este departamento.
                                        </p>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 280, overflowY: 'auto', padding: '4px 2px' }}>
                                            {aaAgents.map(a => {
                                                const uid = String(a._id);
                                                const part = aaParticipants.find(p => p.user === uid);
                                                const isSelected = !!part;
                                                return (
                                                    <div key={a._id} className={`dp-agent-card${isSelected ? ' selected' : ''}`}>
                                                        <label className="dp-agent-row">
                                                            <input type="checkbox" checked={isSelected} onChange={() => toggleParticipant(uid)} />
                                                            <span className="dp-agent-name">{a.name}</span>
                                                            <span className="dp-agent-email">· {a.email}</span>
                                                        </label>
                                                        {isSelected && editCases.length > 0 && (
                                                            <div className="dp-cases-row">
                                                                {part.cases.length === 0 && (
                                                                    <span className="dp-cases-empty">Recibe todos los casos</span>
                                                                )}
                                                                {editCases.map((c, i) => {
                                                                    const active = part.cases.includes(c);
                                                                    return (
                                                                        <span key={i}
                                                                            className={`dp-case-pill${active ? ' active' : ''}`}
                                                                            onClick={() => toggleParticipantCase(uid, c)}>
                                                                            {c}
                                                                        </span>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>

                                {(isAdmin || isLeaderRole) && (
                                    <>
                                        <hr className="dp-msection-divider" />
                                        <div className="dp-mgroup">
                                            <div className="dp-flag-row">
                                                <label className="dp-switch">
                                                    <input type="checkbox" checked={!!aaBreaks.enabled} onChange={e => setAaBreaks(b => ({ ...b, enabled: e.target.checked }))} />
                                                    <span className="dp-switch-slider" />
                                                </label>
                                                <span className="dp-flag-label">Permitir que los agentes tomen pausas (retira del RR)</span>
                                            </div>
                                        </div>
                                        {aaBreaks.enabled && (
                                            <div className="dp-grid-2">
                                                <div>
                                                    <label className="dp-mlabel" style={{ fontSize: 12 }}>Duración comida (min)</label>
                                                    <input type="number" min={1} max={240} className="dp-input"
                                                        value={aaBreaks.lunchMinutes}
                                                        onChange={e => setAaBreaks(b => ({ ...b, lunchMinutes: Number(e.target.value) }))} />
                                                </div>
                                                <div>
                                                    <label className="dp-mlabel" style={{ fontSize: 12 }}>Duración pausa corta (min)</label>
                                                    <input type="number" min={1} max={120} className="dp-input"
                                                        value={aaBreaks.shortMinutes}
                                                        onChange={e => setAaBreaks(b => ({ ...b, shortMinutes: Number(e.target.value) }))} />
                                                </div>
                                                <div>
                                                    <label className="dp-mlabel" style={{ fontSize: 12 }}>Comidas por día</label>
                                                    <input type="number" min={0} max={5} className="dp-input"
                                                        value={aaBreaks.lunchPerDay}
                                                        onChange={e => setAaBreaks(b => ({ ...b, lunchPerDay: Number(e.target.value) }))} />
                                                </div>
                                                <div>
                                                    <label className="dp-mlabel" style={{ fontSize: 12 }}>Pausas cortas por día</label>
                                                    <input type="number" min={0} max={10} className="dp-input"
                                                        value={aaBreaks.shortPerDay}
                                                        onChange={e => setAaBreaks(b => ({ ...b, shortPerDay: Number(e.target.value) }))} />
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        {(isAdmin || isLeaderRole) && (
                            <>
                                <hr className="dp-msection-divider" />
                                <div className="dp-mgroup">
                                    <div className="dp-flag-row">
                                        <label className="dp-switch">
                                            <input type="checkbox" checked={guard.enabled} onChange={e => setGuard(g => ({ ...g, enabled: e.target.checked }))} />
                                            <span className="dp-switch-slider" />
                                        </label>
                                        <span className="dp-flag-label">Guardias de sábado automáticas (rotación)</span>
                                    </div>
                                    <p className="dp-mhint">
                                        Cada semana el sistema llena los turnos del sábado y lo escribe en el horario de cada agente:
                                        va quien lleva más tiempo sin guardia y recibe el turno que lleva más tiempo sin hacer.
                                        Vacaciones y feriados se saltan sin perder el turno. El aviso llega en sesión a las 11:00.
                                        Puedes ver y cambiar el calendario en <b>Administración → Guardias de sábado</b>.
                                    </p>
                                </div>

                                {guard.enabled && (
                                    <>
                                        <div className="dp-mgroup">
                                            <label className="dp-mlabel">
                                                Turnos del sábado
                                                <span style={{ fontWeight: 400, color: 'var(--c-text-4)', marginLeft: 6 }}>
                                                    ({guard.slots.reduce((n, s) => n + (Number(s.count) || 0), 0)} lugares en total)
                                                </span>
                                            </label>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                                {guard.slots.map((s, i) => (
                                                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr 1fr 1fr 70px 32px', gap: 6, alignItems: 'center' }}>
                                                        <input type="text" className="dp-input sm" placeholder="Nombre" value={s.label}
                                                            onChange={e => updateSlot(i, { label: e.target.value })} />
                                                        <select className="dp-select sm" value={s.mode} onChange={e => updateSlot(i, { mode: e.target.value })}>
                                                            <option value="oficina">Oficina</option>
                                                            <option value="home">Home office</option>
                                                        </select>
                                                        <input type="time" className="dp-input sm" value={s.start} onChange={e => updateSlot(i, { start: e.target.value })} />
                                                        <input type="time" className="dp-input sm" value={s.end} onChange={e => updateSlot(i, { end: e.target.value })} />
                                                        <input type="number" min={1} max={20} className="dp-input sm" title="Lugares" value={s.count}
                                                            onChange={e => updateSlot(i, { count: Number(e.target.value) })} />
                                                        <button type="button" className="dp-btn dp-btn-ghost" style={{ padding: '4px 6px' }} aria-label="Quitar turno" onClick={() => removeSlot(i)}>{I.x}</button>
                                                    </div>
                                                ))}
                                            </div>
                                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, flexWrap: 'wrap' }}>
                                                <button type="button" className="dp-btn dp-btn-info" onClick={addSlot}>Agregar turno</button>
                                                <span className="dp-mhint" style={{ margin: 0 }}>Nombre · modalidad · inicio · fin · lugares. El horario del turno se escribe en el sábado del agente.</span>
                                            </div>
                                        </div>
                                        <div className="dp-grid-2">
                                            <div>
                                                <label className="dp-mlabel" style={{ fontSize: 12 }}>Sábados programados por adelantado</label>
                                                <input type="number" min={1} max={12} className="dp-input" value={guard.weeksAhead}
                                                    onChange={e => setGuard(g => ({ ...g, weeksAhead: Number(e.target.value) }))} />
                                            </div>
                                        </div>

                                        <div className="dp-mgroup" style={{ marginTop: 12 }}>
                                            <label className="dp-mlabel">
                                                Agentes en la rotación de guardias
                                                <span style={{ fontWeight: 400, color: 'var(--c-text-4)', marginLeft: 6 }}>
                                                    ({guard.participants.length} seleccionados)
                                                </span>
                                            </label>
                                            {aaAgents.length === 0 ? (
                                                <p style={{ color: 'var(--c-text-4)', fontSize: 12, fontStyle: 'italic' }}>
                                                    No hay agentes activos asignados a este departamento.
                                                </p>
                                            ) : (
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 240, overflowY: 'auto', padding: '4px 2px' }}>
                                                    {aaAgents.map(a => {
                                                        const uid = String(a._id);
                                                        const isSelected = guard.participants.includes(uid);
                                                        return (
                                                            <div key={`g-${a._id}`} className={`dp-agent-card${isSelected ? ' selected' : ''}`}>
                                                                <label className="dp-agent-row">
                                                                    <input type="checkbox" checked={isSelected} onChange={() => toggleGuardParticipant(uid)} />
                                                                    <span className="dp-agent-name">{a.name}</span>
                                                                    <span className="dp-agent-email">· {a.email}</span>
                                                                </label>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="dp-btn dp-btn-ghost" onClick={() => setShowEdit(false)}>Cancelar</button>
                        <button type="button" className="dp-btn dp-btn-primary" onClick={handleSaveEdit} disabled={savingEdit}>
                            {savingEdit ? <Spinner size="sm" animation="border" /> : <>{I.check} Guardar</>}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
}
